import { Container, Sprite, Spritesheet } from 'pixi.js';

import { createPlayerOverlayContainer } from './player-components/player.helper';

/**
 * Helper class for managing mute overlay sprites
 */
export class MuteOverlaySprites {
  private _overlay: Container;
  public videoOverlayIconBig!: Sprite;
  public micOverlayIcon!: Sprite;
  public videoOverlayIcon!: Sprite;

  public constructor(diameter: number, sprites: Spritesheet) {
    this._overlay = createPlayerOverlayContainer(sprites, { diameter, spriteName: 'mute-icons-overlay' });
    this._overlay.visible = true;
    if (!sprites.textures) {
      return;
    }
    const videoOverlayIcon = Sprite.from(sprites.textures['video_off.svg']);
    videoOverlayIcon.name = 'videoOverlayIcon';
    videoOverlayIcon.anchor.set(0.5, 0.5);
    videoOverlayIcon.position.set(-35, 0);
    videoOverlayIcon.alpha = 0.8;
    videoOverlayIcon.visible = false;

    const videoOverlayIconBig = Sprite.from(sprites.textures['video_off_big.svg']);
    videoOverlayIconBig.name = 'videoOverlayIconBig';
    videoOverlayIconBig.anchor.set(0.5, 0.5);
    videoOverlayIconBig.position.set(0, 0);
    videoOverlayIconBig.visible = false;
    videoOverlayIconBig.alpha = 0.8;

    const micOverlayIcon = Sprite.from(sprites.textures['mic_off.svg']);
    micOverlayIcon.name = 'micOverlayIcon';
    micOverlayIcon.anchor.set(0.5, 0.5);
    micOverlayIcon.position.set(35, 0);
    micOverlayIcon.alpha = 0.8;
    micOverlayIcon.visible = false;

    this._overlay.addChild(videoOverlayIcon);
    this._overlay.addChild(micOverlayIcon);
    this._overlay.addChild(videoOverlayIconBig);

    this.micOverlayIcon = micOverlayIcon;
    this.videoOverlayIcon = videoOverlayIcon;
    this.videoOverlayIconBig = videoOverlayIconBig;
  }

  public get overlay(): Container {
    return this._overlay;
  }

  public set visible(value: boolean) {
    this._overlay.visible = value;
  }

  public get visible(): boolean {
    return this._overlay.visible;
  }
}
